export const toFixNumber = (value: number, x?: number) => {
  if (value && /\d+\.\d{3,}/.test(String(value))) {
    return Number(value).toFixed(2);
  }
  return value;
};
